/** 得意先別実績画面のデフォルト検索条件 */
export const CUSTOMER_ORDER_HISTORY_DEFAULT_FILTERS = {
  textQuery: '',
  textExact: false,
  startDate: '',
  endDate: '',
};

/**
 * URLSearchParams から得意先別実績のフィルタ状態を構築する。
 * @param {URLSearchParams} searchParams
 */
export function buildCustomerOrderHistoryFiltersFromSearchParams(searchParams) {
  return {
    ...CUSTOMER_ORDER_HISTORY_DEFAULT_FILTERS,
    textQuery: searchParams.get('text_query') || '',
    textExact: searchParams.get('text_exact') === 'true',
    startDate: searchParams.get('start_date') || '',
    endDate: searchParams.get('end_date') || '',
  };
}
